module.exports = "/assets/image-left.jpg?oeBliGG";